export const environment = {
    production: false,
    name: 'stage',
    apiURL: 'https://assign-stage-api.canadianvisa.org/',
    eventURL: 'http://95.85.55.135:83/',
    centURL: 'wss://mario-cent-dev.canadianvisa.org/connection/websocket?format=protobuf',
    marioURL: 'https://mario-dev.canadianvisa.org/',
};
